// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/attention.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteModal_overlay__lf4vL {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.deleteModal_modal__A-jpN {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 400px;
  position: relative;
  text-align: left;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
}

.deleteModal_closeButton__RtnPi {
    font-size: 22px;
    position: absolute;
    right: 15px;
    top: 15px;
    font-size: 20px;
    background: none;
    border: none;
    cursor: pointer;
}

.deleteModal_title__KCMyg {
  font-size: 24px;
  font-weight: bold;
}

.deleteModal_text__iiCbi {
  font-size: 16px;
  line-height: 20px;
  color: #555;
}

.deleteModal_productName__S7ivo {
  font-weight: bold;
  margin: 10px 0;
  color: #222;
}

.deleteModal_buttons__Vgpm\\+ {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
}

.deleteModal_cancelButton__0TRZP,
.deleteModal_deleteButton__23v-8 {
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}

.deleteModal_cancelButton__0TRZP {
  background-color: #eee;
  color: #333;
}

.deleteModal_deleteButton__23v-8 {
  background-color: #e53935;
  color: #fff;
}

.deleteModal_productList__hR09E {
  margin-top: 10px;
  padding-left: 0;
  list-style: none;
  max-height: 80px;         
  overflow-y: auto;         
  border: 1px solid #eee;
  padding: 10px;
  background-color: #fafafa;
  border-radius: 4px;
}

.deleteModal_productName__S7ivo {
  font-size: 14px;
  margin-bottom: 5px;
  color: #333;
  font-weight: 500;
  word-break: break-word;
}

.deleteModal_attentionHead__SkbvP {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.deleteModal_attentionImg__7jdER {
    margin-right: 8px;
    display: inline-block;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    width: 28px;
    height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/styles/deleteModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,yDAA4C;IAC5C,4BAA4B;IAC5B,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal {\n  background-color: #fff;\n  padding: 30px;\n  border-radius: 12px;\n  width: 400px;\n  position: relative;\n  text-align: left;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.2);\n}\n\n.closeButton {\n    font-size: 22px;\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    font-size: 20px;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.text {\n  font-size: 16px;\n  line-height: 20px;\n  color: #555;\n}\n\n.productName {\n  font-weight: bold;\n  margin: 10px 0;\n  color: #222;\n}\n\n.buttons {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.cancelButton,\n.deleteButton {\n  padding: 10px 20px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.cancelButton {\n  background-color: #eee;\n  color: #333;\n}\n\n.deleteButton {\n  background-color: #e53935;\n  color: #fff;\n}\n\n.productList {\n  margin-top: 10px;\n  padding-left: 0;\n  list-style: none;\n  max-height: 80px;         \n  overflow-y: auto;         \n  border: 1px solid #eee;\n  padding: 10px;\n  background-color: #fafafa;\n  border-radius: 4px;\n}\n\n.productName {\n  font-size: 14px;\n  margin-bottom: 5px;\n  color: #333;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.attentionHead {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.attentionImg {\n    margin-right: 8px;\n    display: inline-block;\n    background-image: url(/public/attention.png);\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 28px;\n    height: 28px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `deleteModal_overlay__lf4vL`,
	"modal": `deleteModal_modal__A-jpN`,
	"closeButton": `deleteModal_closeButton__RtnPi`,
	"title": `deleteModal_title__KCMyg`,
	"text": `deleteModal_text__iiCbi`,
	"productName": `deleteModal_productName__S7ivo`,
	"buttons": `deleteModal_buttons__Vgpm+`,
	"cancelButton": `deleteModal_cancelButton__0TRZP`,
	"deleteButton": `deleteModal_deleteButton__23v-8`,
	"productList": `deleteModal_productList__hR09E`,
	"attentionHead": `deleteModal_attentionHead__SkbvP`,
	"attentionImg": `deleteModal_attentionImg__7jdER`
};
export default ___CSS_LOADER_EXPORT___;
